import React, { useState } from 'react';

import '../../css/components/TruckLoanForm.css';

import { Message } from '../../utils';

const CancelTruckLoanApplicationForm = ({
    deliverOrder,
    loanApplication,
    onSubmit,
    onCancel
}) => {

    const cancelReasons = [
        { value: 'personal_reason', label: '客人原因' },
        { value: 'weather', label: '天氣因素' },
        { value: 'other', label: '其他' }
    ];

    const [selectedReason, setSelectedReason] = useState('');
    const [additionalNotes, setAdditionalNotes] = useState('');

    const handleReasonSelect = (reason) => {
        setSelectedReason(reason);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!selectedReason) {
            Message('請選擇取消原因', 'warning');
            return;
        }

        const selectedReasonLabel = cancelReasons.find(r => r.value === selectedReason)?.label || selectedReason;

        const submitData = {
            cancelReason: `${selectedReasonLabel}${additionalNotes ? '\n補充: ' + additionalNotes : ''}`
        };

        if (onSubmit) onSubmit(submitData);
    };

    const ReasonButton = ({ reason }) => {
        const isSelected = selectedReason === reason.value;
        return (
            <div
                onClick={() => handleReasonSelect(reason.value)}
                style={{
                    flex: 1,
                    padding: '12px',
                    textAlign: 'center',
                    borderRadius: '6px',
                    border: `2px solid ${isSelected ? '#000' : '#ddd'}`,
                    backgroundColor: isSelected ? '#000' : '#fff',
                    color: isSelected ? '#fff' : '#333',
                    cursor: 'pointer',
                    transition: 'all 0.2s',
                    fontSize: '0.9rem',
                    fontWeight: isSelected ? 'bold' : 'normal'
                }}
            >
                {reason.label}
            </div>
        );
    };

    return (
        <div className="truck-loan-form-container">
            <div className="truck-loan-form-header">
                <div className="header-left">
                    <h2>申請取消派車單</h2>
                    <span className="form-number">編號：{deliverOrder?.id || loanApplication?.id || '-'}</span>
                </div>
                {onCancel && (
                    <button type="button" className="btn-close-form" onClick={onCancel} title="關閉">✕</button>
                )}
            </div>

            <form onSubmit={handleSubmit} className="truck-loan-form">

                {/* 派車單資訊 */}
                <div className="form-section">
                    <h3 className="section-title">派車單資訊</h3>

                    <div className="form-row">
                        <div className="form-group">
                            <label>編號</label>
                            <input
                                type="text"
                                value={deliverOrder?.id || '-'}
                                disabled
                                className="readonly-field"
                            />
                        </div>
                        <div className="form-group">
                            <label>司機</label>
                            <input
                                type="text"
                                value={deliverOrder?.name || '-'}
                                disabled
                                className="readonly-field"
                            />
                        </div>
                        <div className="form-group">
                            <label>車牌</label>
                            <input
                                type="text"
                                value={deliverOrder?.plate || '-'}
                                disabled
                                className="readonly-field"
                            />
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="form-group full-width">
                            <label>派車用途</label>
                            <input
                                type="text"
                                value={loanApplication?.purpose || '-'}
                                disabled
                                className="readonly-field"
                            />
                        </div>
                    </div>
                </div>

                {/* 取消原因選擇 */}
                <div className="form-section">
                    <h3 className="section-title">取消原因 <span className="required">*</span></h3>

                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))', gap: '10px', marginBottom: '16px' }}>
                        {cancelReasons.map(reason => (
                            <ReasonButton key={reason.value} reason={reason} />
                        ))}
                    </div>
                </div>

                {/* 補充說明 */}
                <div className="form-section">
                    <h3 className="section-title">補充說明 (選填)</h3>

                    <div className="form-row">
                        <div className="form-group full-width">
                            <textarea
                                name="additionalNotes"
                                value={additionalNotes}
                                onChange={(e) => setAdditionalNotes(e.target.value)}
                                placeholder="如有其他說明事項，請在此補充..."
                                rows={4}
                            />
                        </div>
                    </div>
                </div>

                {/* 提交按鈕 */}
                <div className="form-actions">
                    <button type="button" className="btn-cancel" onClick={onCancel}>取消</button>
                    <button type="submit" className="btn-submit">確認申請取消</button>
                </div>
            </form>
        </div>
    );
};

export { CancelTruckLoanApplicationForm };
